import ExploreWrapper from 'components/pages/explore/explorewrapper/ExploreWrapper';

import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import { NextSeo } from 'next-seo';

const ExplorePage = () => {
	const seoProps = generateSeoProps({
		title: 'Pharmuni Courses: Explore Pharma Courses by Skill Level',
		description: 'Browse 50+ ISO-backed GMP, QA & validation courses. Filter by topic or proficiency and enroll instantly to advance your pharmaceutical career.',
		canonical: 'explore',
		noIndex: false
	});
	return (
		<>
			<NextSeo {...seoProps} />
			<ExploreWrapper />
		</>
	);
};

export default ExplorePage;
